/*
 * laser-settings-favorites.js
 * Mirrors the wishlist pattern from customer-features.js, scoped to
 * laser_setting metaobjects.
 *
 *   - localStorage works for everyone (logged-in or guest)
 *   - logged-in customers also sync via the App Proxy worker at
 *     /apps/customer-features/laser-favorites
 *   - on login the guest list is merged into the customer's saved list
 *
 * The grid (sections/laser-settings-grid.liquid) renders a heart per
 * card with `.js-laser-fav-btn` + data-setting-* attributes. A separate
 * "Favourites only" filter chip filters the grid to favourited cards.
 */
(function () {
  if (window.__laserFavoritesWired) return;
  window.__laserFavoritesWired = true;

  var customerId  = window.__wishlistCustomerId; // reuse the same customer ID injection
  var STORAGE_KEY = customerId ? 'laser_favs_' + customerId : 'laser_favs_guest';
  var GUEST_KEY   = 'laser_favs_guest';
  var SYNC_URL    = '/apps/customer-features/laser-favorites';

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (_) { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function has(id) {
    return load().some(function (f) { return String(f.id) === String(id); });
  }

  function add(entry) {
    var items = load();
    if (!items.some(function (f) { return String(f.id) === String(entry.id); })) {
      items.push(entry);
      save(items);
    }
  }

  function remove(id) {
    save(load().filter(function (f) { return String(f.id) !== String(id); }));
  }

  function getAll() { return load(); }

  function mergeUnique() {
    var seen = {};
    var out = [];
    for (var i = 0; i < arguments.length; i++) {
      var list = arguments[i];
      if (!Array.isArray(list)) continue;
      for (var j = 0; j < list.length; j++) {
        var item = list[j];
        if (!item || item.id == null) continue;
        var id = String(item.id);
        if (seen[id]) continue;
        seen[id] = true;
        out.push(item);
      }
    }
    return out;
  }

  function sameLists(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    var aIds = {};
    for (var i = 0; i < a.length; i++) aIds[String(a[i].id)] = true;
    for (var j = 0; j < b.length; j++) if (!aIds[String(b[j].id)]) return false;
    return true;
  }

  function pushToServer(items) {
    if (!customerId) return Promise.resolve();
    return fetch(SYNC_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ favorites: items }),
    }).catch(function () { /* silent — localStorage still works */ });
  }

  function syncOnLoad() {
    if (!customerId) return;
    fetch(SYNC_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.favorites)) return;
        var server = data.favorites;
        var local  = load();
        var guest  = [];
        try { guest = JSON.parse(localStorage.getItem(GUEST_KEY) || '[]'); }
        catch (_) {}
        var merged = mergeUnique(server, local, guest);
        if (!sameLists(server, merged)) {
          pushToServer(merged);
        }
        save(merged);
        if (STORAGE_KEY !== GUEST_KEY) {
          localStorage.removeItem(GUEST_KEY);
        }
        updateButtons();
        updateFilterChip();
        document.dispatchEvent(new CustomEvent('laser-favorites:updated'));
      })
      .catch(function () { /* silent */ });
  }

  function updateButtons() {
    document.querySelectorAll('.js-laser-fav-btn').forEach(function (btn) {
      var active = has(btn.dataset.settingId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from favourites' : 'Save to favourites');
    });
  }

  function updateFilterChip() {
    var chip = document.querySelector('[data-laser-fav-filter]');
    if (!chip) return;
    var count = load().length;
    var countEl = chip.querySelector('[data-laser-fav-count]');
    if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
    chip.toggleAttribute('hidden', count === 0);
  }

  var pushTimer = null;
  function schedulePush() {
    if (!customerId) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { pushToServer(load()); }, 400);
  }

  function bindButtons() {
    document.querySelectorAll('.js-laser-fav-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var entry = {
          id:      this.dataset.settingId,
          handle:  this.dataset.settingHandle,
          title:   this.dataset.settingTitle,
          brand:   this.dataset.settingBrand,
          model:   this.dataset.settingModel,
          op:      this.dataset.settingOp,
          power:   this.dataset.settingPower,
          speed:   this.dataset.settingSpeed,
          savedAt: new Date().toISOString(),
        };
        if (has(entry.id)) {
          remove(entry.id);
        } else {
          add(entry);
        }
        updateButtons();
        updateFilterChip();
        schedulePush();
        document.dispatchEvent(new CustomEvent('laser-favorites:updated'));
      });
    });
  }

  window.LaserFavorites = {
    getAll: getAll,
    has: has,
    refreshUI: function () { updateButtons(); updateFilterChip(); },
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindButtons();
    updateButtons();
    updateFilterChip();
    syncOnLoad();
  });
})();
